import { Component, Input, ChangeDetectionStrategy, inject } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { ByocEpisodeService } from '../../../../service/episode.service';
import { ByocEpisodeFetchService } from '../../service/fetch.service';
import { array } from '../../../../../utils';

@Component({
    selector: 'app-byoc-episode-step-fetch-questions-question',
    templateUrl: './question.component.html',
    styleUrls: ['./question.component.scss'],
    // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection -- legacy component, migrate to OnPush when touched
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ByocEpisodeStepGeneralQuestionsQuestionComponent {
    private byocEpisodeService = inject(ByocEpisodeService);
    private byocEpisodeFetchService = inject(ByocEpisodeFetchService);

    @Input()
    formQuestion!: UntypedFormGroup;

    @Input()
    index!: number;

    get editing(): boolean {
        return this.byocEpisodeFetchService.editing;
    }

    editClick(): void {
        if (this.editing) {
            return;
        }
        this.byocEpisodeFetchService.editing = true;
        this.byocEpisodeFetchService.editingIndex = this.index;
        this.byocEpisodeFetchService.updatePs();
    }

    deleteClick(): void {
        if (this.editing) {
            return;
        }
        array(this.byocEpisodeService.form.get('questions')).removeAt(this.index);
        this.byocEpisodeFetchService.updatePs();
    }

    get answersCount(): number {
        return this.formQuestion.value.answers.length;
    }
}
